import ExecutiveIndexPage from './ExecutiveIndexPage';

export default ExecutiveIndexPage;
